import React, { Component } from 'react';
import {
    toast, ToastContainer, MDBCardText, MDBCard, MDBCardTitle, MDBContainer,
    MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBBadge, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter
} from 'mdbreact';
import Header from './ComponentFragments/Header';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Colors from '../Styles/Colors';
import TopSeller from './ComponentFragments/TopSeller';
import SelectSearch from 'react-select-search';
import ReactToPrint from 'react-to-print';
import axios from 'axios';
import AccessManager from '../Utilities/AccessManager';

class Cart extends Component {
    constructor(props) {
        super(props);
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        this.state = {
            cartData: {
                cartItems: []
            },
            dirty: false,
            hotItems: [],
            deliveryOptions: [],
            deliveryCharges: [],
            filteredCharges: [],
            selectedDeliveryOption: 0,
            selectedDeliveryCharge: 0,
            specialsItems: [],
            specialsItemsDisplay: [],
            copaymentsData:[],
            isExperienceCenter: false,
            hasOrder: false,
            orderNo: '-1',
            modalOpen: false,
            acceptedTerms: "false",
            disabled: true,
            paymentRequestId: -1,
            showKit: false,
            availableSfKit: [],
            errorModalOpen: false,
            checkedOutModalOpen: false,
            cartErrorMsg: '',
            courierCharge: 0,
            fname: '',
            lname: '',
            deliveryApartment: '',
            deliveryStreet: '',
            summaryVisible: true,
            deliveryPhone: '',
            deliveryInstructions: '',
            selectedSuburb: '',
            selectedProvince: '',
            orderReference: '',
            stockLimitsData: [],
            qtyCheckModalOpen: false,
            shopSuspended: false,
            cartSyncModalOpen: false,
            cartSyncMessage: '',
            sfComment: '',
            allowPayflex: false,
            payflexModalOPen: false,
            payflexInfoModalOpen: false,
            sessionSyncModal: false,
            balModalOpen: false,
            availableCredit: 0,
            payFlexMsg: '',
            payFlexModalHeader: '',
            paflexModalButtonHidden: true,
            checkOutType: -1,
            useCreditBal: false,
            checked: false,
            addressModalOpen: false,
            showDeliverToManager: true,
            forDelivery: true,
            payLater: false,
            delModeOpen: false,
            isCollection: false,
            updatedQuantitiesAV: []
        }
        this.accessManager = new AccessManager();
        this.formatter = new Formatter();
        this.dl = new DataLayer();
        this.useCredit = this.useCredit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.zeroItem = this.zeroItem.bind(this);
        this.setQty = this.setQty.bind(this);
        this.checkout = this.checkout.bind(this);
        this.resetCart = this.resetCart.bind(this);
        this.updateCart = this.updateCart.bind(this);
        this.filterCharges = this.filterCharges.bind(this);
        this.addSpecial = this.addSpecial.bind(this);
        this.addKit = this.addKit.bind(this);
        this.getDeliveryOptionsDisplay = this.getDeliveryOptionsDisplay.bind(this);
        this.getCartButtons = this.getCartButtons.bind(this);
        //this.getPayflexWidget = this.getPayflexWidget.bind(this);
        this.payNow = this.payNow.bind(this);
        this.payNowMiGS = this.payNowMiGS.bind(this);
        this.payNowPayflex = this.payNowPayflex.bind(this);
        this.successFn = this.successFn.bind(this);
        this.failureFn = this.failureFn.bind(this);
        this.processPaymentResult = this.processPaymentResult.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleErrorInfo = this.toggleErrorInfo.bind(this);
        this.toggleCheckedOutInfo = this.toggleCheckedOutInfo.bind(this);
        this.toggleQtyCheckInfo = this.toggleQtyCheckInfo.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.setChecked = this.setChecked.bind(this);
        this.getKitDisplay = this.getKitDisplay.bind(this);
        this.CheckQuantities = this.CheckQuantities.bind(this);
        this.CheckCreditBal = this.CheckCreditBal.bind(this);
        this.confirmDelMode = this.confirmDelMode.bind(this);
        this.ApplyAvailableQtys = this.ApplyAvailableQtys.bind(this);
        this.forceUpdate = this.forceUpdate.bind(this);
        this.getCartSummary = this.getCartSummary.bind(this);
        this.showPayflexInfo = this.showPayflexInfo.bind(this);
        this.continueWithPayflex = this.continueWithPayflex.bind(this);
        this.GetSpecialsSection = this.GetSpecialsSection.bind(this);
        this.getDelOptionMsg = this.getDelOptionMsg.bind(this);
        this.LoadCopayments = this.LoadCopayments.bind(this);
        this.getCopaymentDisplay = this.getCopaymentDisplay.bind(this);
        this.addCPToCart = this.addCPToCart.bind(this);
        this.getCartOnPageLoad = this.getCartOnPageLoad.bind(this);
        this.filterChargesFromCart = this.filterChargesFromCart.bind(this);
        this.checkUpdatedAvailabilityAV = this.checkUpdatedAvailabilityAV.bind(this);
        this.getLocationDisplay = this.getLocationDisplay.bind(this);
        this.getQtyDisplay = this.getQtyDisplay.bind(this);
    }

    async addKit(item) {
        item.qty = 1;
        let requestObject = {
            shopItem: item,
            deliveryOption: this.state.selectedDeliveryCharge,
            deliverToManager: this.state.checked
        }
        var dl = new DataLayer();
        if (this.state.isExperienceCenter) {
            await dl.Post('/common/AddKitToECCart', item, true, 1);
        } else {
            await dl.Post('/common/AddKitToCart', requestObject, true, 1);
        }
        let response = await this.dl.Get("/common/getcart/" + (this.props.location.state === undefined || this.props.location.state === null ? false : true), 1);
        this.setState({
            cartData: response.data
        })
        this.updateCart();

    }

    async addCPToCart(cpItem) {
        this.props.loaderOn();
        let requestObject = {
            copaymentItem: cpItem,
            deliveryOption: this.state.selectedDeliveryCharge,
            deliverToManager: this.state.checked
        }
        //var deliveryOption = this.state.selectedDeliveryCharge;
        let response = await this.dl.Post('/copayment/addcopaymenttocart', requestObject, false);
        if (response.errorOccurred) {
            toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Error:&nbsp;{ response.errorMessage}</span>, {
                closeButton: false
            });
            this.props.loaderOff();
            //this.setState({ errorModalOpen: true, shopErrorMsg: response.errorMessage });
        } else {
            toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp;Item added successfully. </span>, {
                closeButton: false
            });
            this.updateCart();
        }
    }

    async forceUpdate() {
        this.setState({
            cartSyncModalOpen: false,
            cartSyncMessage: ''
        })
        this.updateCart();
    }


    

    showPayflexInfo(cartObject) {
        this.setState({
            payflexInfoModalOpen: true
        })
    }

    continueWithPayflex() {
        this.setState({
            payflexInfoModalOpen: false
        })

        let requestObject = {
            cartItemList: this.state.cartData.cartItems,
            deliveryOption: this.state.selectedDeliveryCharge,
            isExperienceCenter: this.props.location.state === undefined || this.props.location.state === null ? false : true
        }

        this.payNowPayflex(requestObject);
    }

    async payNowPayflex(cartObject) {
        this.props.loaderOff();
        this.setState({ payflexModalOPen: true, payFlexModalHeader: 'Important', payFlexMsg: 'Transferring you to Payflex, Please do not refresh or close your browser.' })

        let crdt = (parseFloat(this.state.availableCredit.toFixed(2)) * 1);
        crdt = crdt * 10;
        crdt = crdt * 10;

        let requestObject = {
            cartItemList: this.state.cartData.cartItems,
            deliveryOption: this.state.selectedDeliveryCharge,
            isExperienceCenter: this.props.location.state === undefined || this.props.location.state === null ? false : true,
            isPayFlex: true,
            sfComment: this.state.sfComment,
            deliverToManager: this.state.checked
        }

        let response = await this.dl.Post("/Payflex/RequestAuth", requestObject, false, 1);
        console.log(response.data.orderParams.amount);
        let configResponse = await this.dl.GetPayflexConfig(response.data.access_token);
        console.log('Min: ' + configResponse.data.minimumAmount + ' Max: ' + configResponse.data.maximumAmount);

        if (response.data.orderParams.amount < configResponse.data.minimumAmount || response.data.orderParams.amount > configResponse.data.maximumAmount) {
            this.setState({ paflexModalButtonHidden: false, payFlexModalHeader: 'Alert', payFlexMsg: 'Payflex is unavailable for this transaction, please select a different payment method.' })
        } else {

            let orderResponse = await this.dl.PlacePayflexOrder(response.data.orderParams, response.data.access_token);

            let sfOrderPayflexOrder = {
                PayFlexOrderId: orderResponse.data.orderId,
                OrderId: response.data.orderId
            }
            let statusResponse = await this.dl.Post("/Payflex/WritePayflexOrderId", sfOrderPayflexOrder, false, 1);
            //console.log(statusResponse);
            //console.log(orderResponse);
            //get orderid from orderResponse and write away, will need to finalize on our end

            window.location.href = orderResponse.data.redirectUrl;
        }
    }

    confirmDelMode(checkoutType) {
        //alert(this.state.deliveryOptions.length)
        if (this.state.deliveryOptions.length > 1 || this.state.checked) {
            this.setState({ delModeOpen: true, checkOutType: checkoutType });
        } else {
            this.CheckCreditBal(checkoutType);
        }
    }

    async CheckCreditBal(checkOutType) {
        
        var browserSfId = this.TMAUser.data.sfId
        let demCheck = await this.dl.Get('/demonstrator/getServerSfId');

        if (browserSfId != demCheck.data) {
            //alert("This Window is out of sync, please refresh or login again to complete checkout.");
            //this.accessManager.logout();
            this.setState({ sessionSyncModal: true})
        } else {
            this.setState({
                checkOutType: checkOutType,
                delModeOpen:false
            })

            if (checkOutType === 4) {
                this.CheckQuantities(checkOutType, false, 0);
                return;
            }

            let balResponse = await this.dl.Get('/demonstrator/getCurrentBalance');

            if (!balResponse.errorOccurred) {
                if (balResponse.data[0].AllowUseCreditShip && balResponse.data[0].AllowUseCredit) {
                    if ((balResponse.data[0].Balance * -1) > 0) {
                        if (checkOutType == 1) {
                            let amnt = (parseFloat(this.state.cartData.orderTotal.toFixed(2)) * 1);
                            amnt = amnt * 10;
                            amnt = amnt * 10;

                            let crdt = (parseFloat((balResponse.data[0].Balance * -1).toFixed(2)) * 1);
                            crdt = crdt * 10;
                            crdt = crdt * 10;
                            if (crdt >= amnt) {
                                this.setState({
                                    balModalOpen: true,
                                    availableCredit: balResponse.data[0].Balance * -1
                                })
                            } else {
                                this.CheckQuantities(checkOutType, false, 0);
                            }
                        } else {
                            this.setState({
                                balModalOpen: true,
                                availableCredit: balResponse.data[0].Balance * -1
                            })
                        }
                    } else {
                        this.CheckQuantities(checkOutType, false, 0);
                    }
                } else {
                    this.CheckQuantities(checkOutType, false, 0);
                }
            }
        }
    }

    useCredit(use) {
        //if (use) {
        //    this.CheckQuantities(this.state.checkOutType, true, this.state.availableCredit);
        //}
        //if (!use) {
        //    this.CheckQuantities(this.state.checkOutType, false, 0);
        //}
        this.CheckQuantities(this.state.checkOutType, use, this.state.availableCredit)

        this.setState({
            balModalOpen: false,
            useCreditBal: use
        })
    }

    async CheckQuantities(checkOutType, useCredit, creditAmount) {
        this.props.loaderOn();
        let requestObject = {
            cartItemList: this.state.cartData.cartItems,
            deliveryOption: this.state.selectedDeliveryCharge,
            isExperienceCenter: this.props.location.state === undefined || this.props.location.state === null ? false : true
        }

        let response = await this.dl.Post("/shop/checkquantities", requestObject, false, 1);


        if (!response.errorOccurred) {
            if (response.otherInfo == 'true') {
                this.setState({
                    stockLimitsData: response.data,
                    qtyCheckModalOpen: true
                })
            } else {
                //checkOuType 1 = Paylater; 2 = Ecentric, 3 = migs, 4 = Payflex
                // do check to make sure client cart is in sync with cart on server. if not client must refresh/update cart before continuing
                let cartSyncResponse = await this.dl.Post("/cart/CheckCartInSync", requestObject, false, 1);
                if (!cartSyncResponse.errorOccurred) {
                    if (cartSyncResponse.data) {
                        if (checkOutType == 1) {
                            let checkPayLaterResponse = await this.dl.Get("/cart/CheckPaylaterStatus", 1);
                            if (checkPayLaterResponse.data == 1) {
                                let resp = await this.checkout(false, useCredit);
                                if (useCredit) {
                                    if (!resp.error) {
                                        let invResponse = await this.dl.Get("/shop/WriteInvoice/" + resp.orderId, 1);
                                        this.setState({
                                            useCreditBal: false,
                                            availableCredit: 0
                                        });
                                        this.props.history.push({
                                            pathname: '/salesforce/invoiceorder',
                                            search: 'id=' + invResponse.data.invoiceId + '&released=' + true,
                                            state: { documentType: "INVOICE", documentNo: invResponse.data.invoiceId }
                                        })
                                    }
                                }
                            } else {
                                this.setState({ errorModalOpen: true, cartErrorMsg: checkPayLaterResponse.otherInfo });

                            }
                        }
                        if (checkOutType == 2) {
                            this.payNow();
                        }
                        if (checkOutType == 3) {
                            this.payNowMiGS(); //**************Put Back
                        }
                        if (checkOutType == 4) {
                            //this.payNowPayflex(requestObject);
                            this.showPayflexInfo(requestObject); //**************Put Back
                        }
                    } else {
                        this.setState({
                            cartSyncModalOpen: true,
                            cartSyncMessage: cartSyncResponse.otherInfo
                        })
                    }
                } else {
                    alert("An error ocurred validating cart. Please refresh and try again. Error: " + cartSyncResponse.errorMessage)
                }
            }
        } else {
            this.setState({ errorModalOpen: true, cartErrorMsg: response.errorMessage });
        }
        this.props.loaderOff();
    }

    toggleQtyCheckInfo() {
        this.setState({
            qtyCheckModalOpen: false
        });
    }

    toggleCheckedOutInfo() {
        //navigate to invoice page
        this.props.history.push({
            pathname: '/salesforce/invoiceorder',
            search: 'id=' + this.state.orderReference,
            state: { documentType: "PaymentAdvice", documentNo: 0 }
        })
        this.setState({
            checkedOutModalOpen: !this.state.checkedOutModalOpen
        });
    }

    toggleErrorInfo() {
        window.location.reload();
        return false;
    }

    async payNow() {
        this.setState({
            modalOpen: !this.state.modalOpen
        });
        //*********** put back after test
        //let amnt = (parseFloat(this.state.cartData.orderTotal.toFixed(2)) * 1);
        //amnt = amnt * 10;
        //amnt = amnt * 10;
        //let requestObject = {
        //    amount: amnt,
        //    merchantReference: this.state.cartData.cartItems[0].cartId
        //}
        //let response = await this.dl.Post("/shop/paynow", requestObject);
        //window.hpp.payment(response.data, this.successFn, this.failureFn);
        ///////////////*****************************************************
        //this.processPaymentResult(null, true); use this to test with
    }

    async toggle() {
        let amnt = Math.round((this.state.cartData.orderTotal + Number.EPSILON) * 100);
        await this.updateCart();
        let amntTest = Math.round((this.state.cartData.orderTotal + Number.EPSILON) * 100);
        let ssfCartId = this.state.cartData.cartItems[0].cartId;
        
        //amnt = amnt * 10;
        //amnt = amnt * 10;

        //var testAmnt = Math.round((this.state.cartData.orderTotal + Number.EPSILON) * 100);

        var proceedToEcentric = true;
        if (this.state.useCreditBal) {
            let crdt = (parseFloat(this.state.availableCredit.toFixed(2)) * 1);
            crdt = crdt * 10;
            crdt = crdt * 10;
            crdt = (crdt.toFixed(2) * 1);
            if (crdt >= amnt) {
                // no need for ecentric CC payment
                let resp = await this.checkout(false, true);

                if (!resp.error) {
                    let invResponse = await this.dl.Get("/shop/WriteInvoice/" + resp.orderId, 1);
                    this.setState({
                        useCreditBal: false,
                        availableCredit: 0
                    });
                    this.props.history.push({
                        pathname: '/salesforce/invoiceorder',
                        search: 'id=' + invResponse.data.invoiceId + '&released=' + true,
                        state: { documentType: "INVOICE", documentNo: invResponse.data.invoiceId }
                    })
                }

                proceedToEcentric = false;
            } else {
                amnt = amnt - crdt;

            }
        }

        if (proceedToEcentric) {
            
            this.setState({
                modalOpen: !this.state.modalOpen
            });
            let fastwayDeliveryDetail = {
                fname: this.state.fname,
                lname: this.state.lname,
                deliveryApartment: this.state.deliveryApartment,
                deliveryStreet: this.state.deliveryStreet,
                deliveryPhone: this.state.deliveryPhone,
                deliveryInstructions: this.state.deliveryInstructions,
                selectedSuburb: this.state.selectedSuburb,
                selectedProvince: this.state.selectedProvince
            }

            let requestObject = {
                amount: amnt,
                deliveryOption: this.state.selectedDeliveryCharge,
                merchantReference: this.state.cartData.cartItems[0].cartId,
                SSFCartId: ssfCartId,
                courierCharge: this.state.courierCharge,
                fastwayDeliveryDetail: fastwayDeliveryDetail,
                cartItemList: this.state.cartData.cartItems,
                browserSfId: this.TMAUser.data.sfId
            }
            let response = await this.dl.Post("/shop/paynow", requestObject, false, 1);
            if (!response.errorOccurred) {
                this.setState({
                    paymentRequestId: response.data.requestId
                })
                window.hpp.payment(response.data, this.successFn, this.failureFn);
            } else {
                if (response.otherInfo == 'EC01') {
                    this.setState({
                        errorModalOpen: true,
                        cartErrorMsg: response.errorMessage
                    });
                } else {
                    alert("Oops, something seems to have gone wrong. Please log out and back in to try again.");
                }
            }
        }
    }

    async successFn(response) {
        this.processPaymentResult(response, true);
        //console.dir(response);
    }

    async failureFn(response) {
        this.processPaymentResult(response, false);
        //console.dir(response);
    }

    async processPaymentResult(response, success) {
        let ssfCartId = this.state.cartData.cartItems[0].cartId;
        let paymentRequestId = this.state.paymentRequestId;
        let amnt = (parseFloat(this.state.cartData.orderTotal.toFixed(2)) * 1);
        amnt = amnt * 10;
        amnt = amnt * 10;

        if (this.state.useCreditBal) {
            let crdt = (parseFloat(this.state.availableCredit.toFixed(2)) * 1);
            crdt = crdt * 10;
            crdt = crdt * 10;

            amnt = amnt - crdt;


        }

        //let testResponse = ({
        //    MerchantReference: "",
        //    Result: "Success",
        //    FailureMessage: "",
        //    Amount: 12000,
        //    CheckSum:"0A05BB5FCD9D6567F9F78B4C12FdjdjjlE635B24B629A2E742963893E0BC1787D769" use an existing checksum to check response does not get written twice.
        //});
        let paymentResponse = {
            response: response, //testResponse
            SSFCartId: ssfCartId,
            PaymentRequestId: paymentRequestId
        };

        let resp = await this.dl.Post("/shop/PaymentResult", paymentResponse, true, 1, true);
        this.setState({
            paymentRequestId: -1
        })
        if (resp.data) {
            if (success) {
                let resp = await this.checkout(true, this.state.useCreditBal);
                if (!resp.error) {
                    let invResponse = await this.dl.Get("/shop/WriteInvoice/" + resp.orderId + "/" + amnt + "/" + response.MerchantReference + "/" + this.state.useCreditBal, 1);
                    var wtaf = "WTAF";
                    this.setState({
                        orderReference: response.MerchantReference,
                        checkedOutModalOpen: !this.state.checkedOutModalOpen,
                        useCreditBal: false,
                        availableCredit: 0
                    });

                }
            } else {
                this.updateCart();
            }
        }

        //needed if the ref number changes
        if (!success) {
            let ccResp = await this.dl.Get("/shop/CancelCart/" + ssfCartId, 1);
            this.getCartOnPageLoad();
        }

    }

    async payNowMiGS() {
        this.props.loaderOn();
        let nhil = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (2.5 / 100)
        let gfl = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (2.5 / 100)
        let chrl = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (1 / 100);
        let subtotal = (this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue;
        subtotal += nhil + gfl + chrl
        let ghanaTax = subtotal * (12.5 / 100);
        let ghanaInvoiceTotal = subtotal + ghanaTax;

        let amnt = (parseFloat(ghanaInvoiceTotal.toFixed(2)) * 1);
        amnt = amnt * 10;
        amnt = amnt * 10;

        var proceedToMigs = true;
        if (this.state.useCreditBal) {
            let crdt = (parseFloat(this.state.availableCredit.toFixed(2)) * 1);
            crdt = crdt * 10;
            crdt = crdt * 10;
            if (crdt >= amnt) {
                // no need for ecentric CC payment
                let resp = await this.checkout(false, true);

                if (!resp.error) {
                    let invResponse = await this.dl.Get("/shop/WriteInvoice/" + resp.orderId, 1);
                    this.setState({
                        useCreditBal: false,
                        availableCredit: 0
                    });
                    this.props.history.push({
                        pathname: '/salesforce/invoiceorder',
                        search: 'id=' + invResponse.data.invoiceId + '&released=' + true,
                        state: { documentType: "INVOICE", documentNo: invResponse.data.invoiceId }
                    })
                }

                proceedToMigs = false;
            } else {
                amnt = amnt - crdt;

            }
        }

        if (proceedToMigs) {
            let requestObject = {
                amount: amnt,
                merchantReference: this.state.cartData.cartItems[0].cartId,
                deliveryOption: this.state.selectedDeliveryCharge
            }
            let response = await this.dl.Post("/shop/GetRedirectUrl", requestObject, true, 1);
            let UrlAndParams = response.data.split('?');
            let Params = UrlAndParams[1].split("&");
            let MigsForm = document.getElementById("migsForm");//.submit();
            let FN;
            for (var i = 0; i < Params.length; i++) {
                FN = document.createElement("input");
                let keyValPair = Params[i].split("=");
                FN.setAttribute("type", "hidden");
                FN.setAttribute("name", keyValPair[0]);
                FN.setAttribute("id", keyValPair[0]);
                if (keyValPair[0] == 'vpc_ReturnURL') {
                    FN.setAttribute("value", decodeURIComponent(keyValPair[1]));
                } else {
                    FN.setAttribute("value", keyValPair[1]);
                }

                MigsForm.appendChild(FN);
            }
            var test = "";
            MigsForm.submit();
        }
        //window.location.assign(response.data);
    }


    async addSpecial(specialItem) {
        this.props.loaderOn();
        console.log('special Item', specialItem);
        let requestObject = {
            specialItem,
            cartItemList: this.state.cartData.cartItems,
            deliveryOption: this.state.selectedDeliveryCharge,
            isExperienceCenter: this.props.location.state === undefined || this.props.location.state === null ? false : true,
            deliverToManager: this.state.checked
        }
        let response = await this.dl.Post("/common/applyspecial", requestObject, false, 1);
        if (response.errorOccurred) {
            toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Error:&nbsp;{response.errorMessage}</span>, {
                closeButton: false
            });
            this.props.loaderOff();
            //this.setState({ errorModalOpen: true, shopErrorMsg: response.errorMessage });
        } else {
            toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp;Item added successfully. </span>, {
                closeButton: false
            });
            this.updateCart();
        }

    }

    

    async getCartOnPageLoad() {
        this.props.loaderOn();
        //alert(this.TMAUser.data.useOnlinePayments);
        let response = await this.dl.Get("/common/getcart/" + (this.props.location.state === undefined || this.props.location.state === null ? false : true), 1); //**********
        //let hotItems = await this.dl.Get("/common/gethotitems"); in case we want to put top sellers back
        let suspendedResponse = await this.dl.Get('/shop/CheckShopSuspended', 1)
        let result = await this.dl.Get('/demonstrator/GetPersonalInfo', 200);
        console.log("Personal Info", result.data);

        let suburbTown = result.data.dAddressLine3.toLowerCase();
        let postCode = result.data.dPostalCode.toLowerCase();
        let proceed = false;
        if (this.TMAUser.data.countryId == 6) {
            const Apiresponse = await axios.get(`https://api.siteway.co.za/fastway/woo/v1/find-suburb-province-all/?query=${suburbTown}`);
            const json = Apiresponse.data;
            console.log("API Addresses:", json);
            if (json === null || json === undefined) {
                this.setState({ addressModalOpen: true })
            } else {
                json.forEach((item) => {
                    const text = item.text;
                    var str = item.text;
                    var res = str.split("(");
                    var town = res[0].trim();
                    var provPart = res[res.length - 1];
                    provPart = provPart.split("-");//[0].trim().toUpperCase();
                    var apiPostCode = '';
                    if (provPart.length == 3) {
                        apiPostCode = provPart[2].trim();
                    } else {
                        apiPostCode = provPart[1].trim();
                    }
                    apiPostCode = apiPostCode.substring(0, apiPostCode.length - 1);

                    if (town.trim().toLowerCase() === suburbTown.trim().toLowerCase() && apiPostCode.trim() === postCode.trim()) {
                        proceed = true;
                    }
                });
            }
        } else {
            proceed = true;
        }


        if (!proceed) {
            this.setState({ addressModalOpen: true })
        }



        if (!suspendedResponse.data.mobiOrderingAllowed) {
            this.props.loaderOff();
            this.setState({ shopSuspended: true });
        } else {
            let deliveryCharges = await this.dl.Get("/common/getdeliveryoptions", 1);

            //let specialsItems = await this.dl.Get("/common/getspecialsitems/" + (this.props.location.state === undefined ? false : true));**************

            let defaultDelivery = deliveryCharges.data.filter((item) => item.isDefault === true);
            let dispatchType = defaultDelivery[0].dispatchType;
            let payLaterResult = defaultDelivery[0].payLater;

            console.log('delivery Charges', deliveryCharges);
            console.log('Pay Later Result', payLaterResult);

            let procCode1 = this.TMAUser.data.countryId == 6 ? '991527' : '991529';
            let procCode2 = this.TMAUser.data.countryId == 6 ? '991528' : '991530';
            let item = response.data.cartItems[0]
            let deliveryOptions = [];

            if (deliveryCharges.data.some(e => e.dispatchType === 1)) {
                if (this.TMAUser.data.countryId == 6) {
                    //if (item.processingCode == procCode1 || item.processingCode == procCode2) {
                    deliveryOptions.push({ name: "Collect", value: 1 })
                    dispatchType = 1
                    //}
                } else {
                    deliveryOptions.push({ name: "Collect", value: 1 })
                    dispatchType = 1
                }
            }

            if (response.data.cartItems.length > 0) {


                if (item.processingCode == procCode1 || item.processingCode == procCode2) {
                    dispatchType = 1;
                } else {
                    if (deliveryCharges.data.some(e => e.dispatchType === 2)) {
                        deliveryOptions.push({ name: "Deliver", value: 2 })
                        dispatchType = 2;
                    }
                }
            } else {
                if (deliveryCharges.data.some(e => e.dispatchType === 2)) {
                    deliveryOptions.push({ name: "Deliver", value: 2 })
                    dispatchType = 2;
                }
            }

            //can refactor *********************************************
            //let cartItemData = response.data.cartItems;
            //let specialsItemsDisplay = Array.from(specialsItems.data);
            //cartItemData.forEach((item) => {
            //    let sIndex = specialsItemsDisplay.findIndex((sItem) => sItem.getProcessingCode === item.processingCode);
            //    if (sIndex != -1) {
            //        specialsItemsDisplay.splice(sIndex, 1);
            //    }
            //})

            //if (response.data.discountValue > 0) {
            //    //remove any discount type specials

            //}

            //*************************************************************

            this.setState({
                allowPayflex: suspendedResponse.data.allowPayflex,
                cartData: response.data,//***********
                deliveryCharges: deliveryCharges.data,
                //specialsItems: specialsItems.data, *************
                isExperienceCenter: this.props.location.state === undefined || this.props.location.state === null ? false : true,
                hasOrder: this.props.location.state === undefined || this.props.location.state === null ? false : this.props.location.state.hasOrder ? true : false,
                orderNo: this.props.location.state === undefined || this.props.location.state === null ? '-1' : this.props.location.state.orderNo,
                showDeliverToManager: dispatchType == 1 ? false : true,
                payLater: payLaterResult,
                deliveryOptions,

            })

            //this.filterCharges(defaultDelivery[0].dispatchType);

            if (this.TMAUser.data.countryId === 6) {
                //get dispatch chosen when adding to cart
                let dispOption = await this.dl.Get("/cart/GetCartDispatchOptions", 1);
                await this.filterChargesFromCart(dispOption.data.dispatchType, dispOption.data.dispatchChargeId, dispOption.data.deliverToManager)
                var jhgfhjgvh = '';
            } else {
                this.filterCharges(dispatchType);
            }
            //this.filterCharges(dispatchType);
            console.log('Cart Data', this.state.cartData)
        }
        //this.props.loaderOff()
    }
    
    async componentWillMount() {
        this.getCartOnPageLoad();
    }

    async filterChargesFromCart(dispatchType, dispatchChargeId, deliverToManager) {
        let items = this.state.deliveryCharges.filter((item) => item.dispatchType === dispatchType);
        let cartDeliveryCharge = this.state.deliveryCharges.filter((item) => item.dispatchChargeId === dispatchChargeId);
        let filteredCharges = [];
        items.forEach((item) => {
            filteredCharges.push({ name: item.description, value: item })
        })
        this.setState({
            filteredCharges,
            selectedDeliveryOption: dispatchType,
            selectedDeliveryCharge: cartDeliveryCharge[0],
            forDelivery: dispatchType == 1 ? false : true,
            isCollection: dispatchType == 1 ? true : false,
            checked: deliverToManager
        })
        await this.updateCart();
    }

    filterCharges(dispatchType) {
        let items = this.state.deliveryCharges.filter((item) => item.dispatchType === dispatchType);
        
        let filteredCharges = [];
        items.forEach((item) => {
            filteredCharges.push({ name: item.description, value: item })
        })
        this.setState({
            filteredCharges,
            selectedDeliveryOption: dispatchType,
            selectedDeliveryCharge: items[0],
            forDelivery: dispatchType == 1 ? false : true,
            isCollection: dispatchType == 1 ? true : false,
            checked: dispatchType == 1 ? false : this.state.checked
        })
        this.updateCart();
    }

    async ApplyAvailableQtys() {
        let cartData = this.state.cartData;
        let availableQtys = this.state.stockLimitsData;
        let AVAvailable = this.state.updatedQuantitiesAV;
        console.log('available qtys ', AVAvailable);

        if (this.TMAUser.data.countryId === 6) {
            for (var i = 0; i < AVAvailable.length; i++) {
                for (var x = 0; x < cartData.cartItems.length; x++) {
                    if (cartData.cartItems[x].stockId == AVAvailable[i].stockId) {
                        if (!AVAvailable[i].canFullfillSecondary && !AVAvailable[i].canFullfillPrimary) {
                            if (AVAvailable[i].qtyAvailableSecondary > AVAvailable[i].qtyAvailablePrimary) {
                                cartData.cartItems[x].qty = AVAvailable[i].qtyAvailableSecondary
                            } else {
                                cartData.cartItems[x].qty = AVAvailable[i].qtyAvailablePrimary
                                cartData.cartItems[x].avReservationWHCode = 'Prim'
                            }
                        } else if (AVAvailable[i].canFullfillPrimary) {
                            cartData.cartItems[x].avReservationWHCode = 'Prim'
                        }

                    }
                }
            }
        } else {
            for (var i = 0; i < availableQtys.length; i++) {
                for (var x = 0; x < cartData.cartItems.length; x++) {
                    if (cartData.cartItems[x].shipStockId == 0) {
                        if (cartData.cartItems[x].stockId == availableQtys[i].stockId) {
                            cartData.cartItems[x].qty = availableQtys[i].availableToOrder
                        }
                    } else {
                        if (cartData.cartItems[x].shipStockId == availableQtys[i].shipStockId) {
                            cartData.cartItems[x].qty = availableQtys[i].availableToOrder
                        }
                    }
                }
            }
        }

        this.setState({
            cartData,
            dirty: true,
            qtyCheckModalOpen: false
        })

        await this.checkUpdatedAvailabilityAV(true);
    }

    async checkUpdatedAvailabilityAV(updateCart) {
        this.props.loaderOn();
        let requestObject = {
            cartItemList: this.state.cartData.cartItems,
            deliveryOption: this.state.selectedDeliveryCharge,
            isExperienceCenter: this.props.location.state === undefined || this.props.location.state === null ? false : true,
            updateCart: updateCart
        }
        let response = await this.dl.Post("/cart/CheckUpdatedAvailabilityAV", requestObject, true, 1);
        if (!response.errorOccurred) {
            if (response.data.length > 0) {
                this.setState({ updatedQuantitiesAV: response.data, qtyCheckModalOpen: true })
            } else {
                await this.getCartOnPageLoad();
                //await this.updateCart()
            }
        } else {
            console.log('error updating cart ', response.data);
            alert("An error occurred retrieving updated quantites for items in your cart")
        }
        console.log("Updated Qtys Avail", response.data)
        this.props.loaderOff();
    }

    async updateCart() {
        this.props.loaderOn();
        //if (this.state.cartData.cartItems.length > 0) {
        let requestObject = {
            cartItemList: this.state.cartData.cartItems,
            deliveryOption: this.state.selectedDeliveryCharge,
            isExperienceCenter: this.props.location.state === undefined || this.props.location.state === null ? false : true
        }

        let response = await this.dl.Post("/common/updatecart", requestObject, true, 1);
        if (!response.errorOccurred) {
            let specialsItems = await this.dl.Get("/common/getspecialsitems/" + (this.props.location.state === undefined || this.props.location.state === null ? false : true) + "/" + (this.state.cartData.cartItems.length > 0 ? this.state.cartData.cartItems[0].cartId : -1), 1);

            let demKitCheckData = await this.dl.Get("/demonstrator/getsfkitcheckdata", 1);

            let test = "";
            // can refactor *********************************************
            let cartItemData = response.data.cartItems;
            let specialsItemsDisplay = Array.from(specialsItems.data);
            let kitAdded = false;
            cartItemData.forEach((item) => {
                let sIndex = specialsItemsDisplay.findIndex((sItem) => sItem.getProcessingCode === item.processingCode);
                if (sIndex != -1) {
                    specialsItemsDisplay.splice(sIndex, 1);
                }
                if (item.kit) {
                    kitAdded = true;
                }
            })

            if (response.data.discountValue > 0) {
                //remove any discount type specials
                specialsItemsDisplay.forEach((item, index) => {
                    if (item.outcomeType === "Or") {
                        specialsItemsDisplay.splice(index, 1);
                    }
                })
            }

            //***********************************************************
            this.props.updateCartCount(response.data.cartItems.length);

            let cartTotal = 0;//response.data.recognitionTotal + demKitCheckData.data.salesToDate;//total recognition in cart currently :this.state.cartData.recognitionTotal
            if (demKitCheckData.data.salesToDate >= demKitCheckData.data.kitLevel) {
                cartTotal = demKitCheckData.data.salesToDate
            } else {
                cartTotal = response.data.recognitionTotal + demKitCheckData.data.currSegmentSales
            }
            let passAll = false;
            let sfKit = [];

            if (!kitAdded) {
                if ((demKitCheckData.data.monthsOld <= demKitCheckData.data.kitMonths) && (cartTotal >= demKitCheckData.data.kitLevel) && (demKitCheckData.data.kitStockId == 0)) {
                    let sfKitResponse = await this.dl.Get("/demonstrator/getsfkit", 1);
                    sfKit = sfKitResponse.data;
                    passAll = sfKitResponse.data === null ? false : true;
                }
            }

            if (demKitCheckData.data.kitOrderCount > 0) {
                passAll = false;
            }

            //load copayments
            var copaymentsData = await this.LoadCopayments();
            var copayDisplay = [];
            var usertype = this.TMAUser.data.statusCode1 + this.TMAUser.data.statusCode2;
            if (response.data.cartItems.length > 0) {
                for (var i = 0; i < copaymentsData.length; i++) {
                    if (copaymentsData[i].orderingOpen) {
                        for (var ii = 0; ii < copaymentsData[i].copaymentLevels.length; ii++) {
                            if ((copaymentsData[i].copaymentLevels[ii].currentKPILevelAchieved + response.data.recognitionTotal) > copaymentsData[i].copaymentLevels[ii].coPaymentLevelValue) {
                                if (!copaymentsData[i].copaymentLevels[ii].alreadyOptedIn) {
                                    if (!copaymentsData[i].copaymentLevels[ii].addedToCart) {
                                        var copayStatus = copaymentsData[i].copaymentLevels[ii].statusCode1 + copaymentsData[i].copaymentLevels[ii].statusCode2;
                                        if (usertype.toLowerCase().trim() == copayStatus.toLowerCase().trim()) {
                                            copayDisplay.push(copaymentsData[i].copaymentLevels[ii]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            

            this.setState({
                cartData: response.data,
                specialsItems: specialsItems.data,
                specialsItemsDisplay,
                dirty: false,
                showKit: passAll,
                availableSfKit: sfKit,
                copaymentsData: copayDisplay
            })
            // }

        } else {
            alert("An error occurred updating cart. Please try again.")
        }


        this.props.loaderOff();
    }

    async LoadCopayments() {
        let coPaymentResult = await this.dl.Get('/copayment/GetCopaymentProcessingItems', 200);
        return coPaymentResult.data;
    }

    resetCart() {
        let cartData = this.state.cartData;

        cartData.cartItems.forEach((item) => item.qty = item.originalQty);

        this.setState({
            cartData,
            dirty: false
        })
    }

    zeroItem(item) {
        this.setQty(0, item);
    }

    setQty(qty, item) {
        let cartData = this.state.cartData
        let index = -1;
        if (item.stockId != 0) {
            index = cartData.cartItems.findIndex((i) =>
                i.stockId == item.stockId
            );

        } else {
            index = cartData.cartItems.findIndex((i) =>
                i.shipStockId == item.shipStockId
            );
        }
        cartData.cartItems[index].qty = qty;

        let changedItems = cartData.cartItems.some((i) => i.qty != i.originalQty);

        this.setState({
            cartData,
            dirty: changedItems
        })
    }

    handleCommentChange(event) {
        let comment = event.target.value
        this.setState({
            sfComment: comment
        })

    }

    handleChange(event, item) {
        let qty = event.target.valueAsNumber
        let specialsItems = this.state.specialsItems;
        if (item.specialItem) {
            specialsItems.map(special => {
                special.outcomeList.map(outcomeItem => {
                    if (outcomeItem.outcomeStockId == item.stockId) {
                        if (qty > outcomeItem.maxQty) {
                            qty = outcomeItem.maxQty
                        }
                    }
                })
            })

        }

        

        //let special = this.state.specialsItems.find((sItem) => sItem.getProcessingCode === item.processingCode);
        //if (special !== undefined) {
        //    if (qty > special.maxAllowed) {
        //        qty = special.maxAllowed;
        //    }
        //}

        if (item.coPaymentItem) {
            //get different tier settings and check if more can be added or not.
            // for each tier check how many can be added if multi allowed.
            //disallow if max already added for tier.
            let cartItems = this.state.cartData.cartItems
            var tier = '';
            var maxCanBuy = item.maxLevelsCanBuy;
            var optedInCount = item.optedInCount;
            var canBuyMultiple = item.canBuyMultiple;
            const tierResult = cartItems.filter((tier) => tier.copaymentTier === item.copaymentTier)
            tierResult.map(tItem => {
                if (item.cartItemId != tItem.cartItemId)
                optedInCount += tItem.qty;
            })
            if ((qty + optedInCount) > maxCanBuy) {
                qty = item.originalQty
            }

            
        }

        if (qty < 0) {
            qty = 1;
        }

        let procCode1 = this.TMAUser.data.countryId == 6 ? '991527' : '991529';
        let procCode2 = this.TMAUser.data.countryId == 6 ? '991528' : '991530';
        if (item.processingCode == procCode1 || item.processingCode == procCode2) {
            if (qty > 1) {
                qty = 1;
            }
        }

        this.setQty(qty, item);

    }

    

    async checkout(isPayNow, useCredit) {
        console.log("Deliver to manager.................." + this.state.checked)
        this.props.loaderOn();
        let ssfCartId = this.state.cartData.cartItems[0].cartId;
        let cartResponse = await this.dl.Get("/common/GetCartForEcentric/" + ssfCartId, 1); //**********
        let requestObject = {
            cartItemList: cartResponse.data.cartItems,
            deliveryOption: this.state.selectedDeliveryCharge,
            isExperienceCenter: this.props.location.state === undefined || this.props.location.state === null ? false : true,
            isPayFlex: false,
            sfComment: this.state.sfComment,
            deliverToManager: this.state.checked
        }

        let response = await this.dl.Post("/common/checkout", requestObject, true, 1);
        if (!response.errorOccurred) {
            if (!this.state.isExperienceCenter) {
                this.setState({
                    cartData: {
                        cartItems: []
                    }
                })
                this.props.updateCartCount(0);
                if (!isPayNow) {
                    //toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; Order generated successfully. </span>, {
                    //    closeButton: false
                    //});
                    if (!useCredit) {
                        this.props.history.push({
                            pathname: '/salesforce/invoiceorder',
                            search: 'id=' + response.data + '&released=' + false,
                            state: { documentType: "ORDER", documentNo: response.data }
                        })
                    }
                }
            } else {
                this.setState({
                    hasOrder: true,
                    orderNo: response.data
                });
                toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; Checkout code generated successfully. </span>, {
                    closeButton: false
                });
            }
            let resp = {
                error: false,
                orderId: response.data
            }
            this.props.loaderOff();
            return resp;
        } else {
            let resp = {
                error: true,
                orderId: -1
            }
            this.props.loaderOff();
            return resp;
        }



    }

    setChecked(value) {
        if (value == "false") {
            this.setState({
                checked: true
            })
        } else {
            this.setState({
                checked: false
            })
        }
    }

    changeHandler(value) {
        if (value == "false") {
            let test = value;
            this.setState({
                acceptedTerms: "true",
                disabled: false
            })
        } else {
            let sjdsk = value;
            this.setState({
                acceptedTerms: "false",
                disabled: true
            })
        }

        //alert(this.state.acceptedTerms);
    };

    //getPayflexWidget() {
    //    var el = document.createElement("script");
    //    el.setAttribute("src", "https://widgets.payflex.co.za/your-merchant-name/partpay-widget-0.1.1.js?type=calculator&min=50&max=400&amount=300");
    //    document.getElementById("Widget")[0].appendChild(el);

    //}


    getCartButtons(isExperienceCenter, disableEcCheckout) {
        if (isExperienceCenter) {
            return (
                <MDBCol sm="12" className="text-center">
                    <div hidden={!this.state.dirty}>
                        <MDBBtn rounded color="mdb-color" size="sm" onClick={this.resetCart}><MDBIcon icon="sync-alt" />&nbsp;Reset</MDBBtn>
                        <MDBBtn rounded color="pink" size="sm" onClick={this.updateCart}><MDBIcon icon="arrow-up" />&nbsp;Update</MDBBtn><br />
                        <span style={{ color: "black", fontSize: "14px" }}>Cart has changed, please update to checkout. <br />(Items with 0 quantity will be removed.)</span>
                    </div>
                    <MDBBtn rounded disabled={disableEcCheckout} hidden={this.state.dirty} color="purple" size="sm" onClick={() => this.checkout(false, false)}><MDBIcon icon="shopping-cart" />&nbsp;Generate Checkout Code</MDBBtn>
                </MDBCol>
            )
        } else {
            return (
                <MDBCol sm="12" className="text-center">
                    <div hidden={!this.state.dirty}>
                        <MDBBtn rounded color="mdb-color" size="sm" onClick={this.resetCart}><MDBIcon icon="sync-alt" />&nbsp;Reset</MDBBtn>
                        <MDBBtn rounded color="pink" size="sm" onClick={(this.TMAUser.data.countryId === 6 ? () => this.checkUpdatedAvailabilityAV(false) : this.updateCart)}><MDBIcon icon="arrow-up" />&nbsp;Update</MDBBtn><br />
                        <span style={{ color: "black", fontSize: "14px" }}>Cart has changed, please update to checkout. <br />(Items with 0 quantity will be removed.)</span>
                    </div>
                    {this.state.allowPayflex ? <MDBBtn rounded disabled={this.state.cartData.cartItems.length == 0} hidden={this.state.dirty} color="pink" size="sm" onClick={() => this.confirmDelMode(4)}><MDBIcon icon="shopping-cart" />&nbsp;Checkout<br /> (Pay Now With Payflex)</MDBBtn> : null}

                    {/*{this.TMAUser.data.countryId == 6 ? <div></div> : <MDBBtn rounded disabled={this.state.cartData.cartItems.length == 0} hidden={this.state.dirty} color="cyan" size="sm" onClick={() => this.CheckCreditBal(1)}><MDBIcon icon="shopping-cart" />&nbsp;Checkout<br /> (Pay Via EFT/Bank Dposit<br />Send Proof Within 24Hrs)</MDBBtn>}*/}
                    {this.TMAUser.data.countryId == 6 ? <div><MDBBtn rounded disabled={this.state.cartData.cartItems.length == 0} hidden={this.state.dirty || this.state.forDelivery || !this.state.payLater} color="cyan" size="sm" onClick={() => this.confirmDelMode(1)}><MDBIcon icon="shopping-cart" />&nbsp;Checkout<br /> (Pay At Collection Point<br />With Card. No Cash)</MDBBtn></div> : <MDBBtn rounded disabled={this.state.cartData.cartItems.length == 0} hidden={this.state.dirty} color="cyan" size="sm" onClick={() => this.confirmDelMode(1)}><MDBIcon icon="shopping-cart" />&nbsp;Checkout<br /> (Pay Via EFT/Bank Dposit<br />Send Proof Within 24Hrs)</MDBBtn>}

                    {this.TMAUser.data.useOnlinePayments ? this.TMAUser.data.bankAccountId == -1 ? (<div></div>) :
                        (
                            this.TMAUser.data.paymentGatewayId == 1 ?
                                (
                                    <MDBBtn rounded disabled={this.state.cartData.cartItems.length == 0} hidden={this.state.dirty} color="purple" size="sm" onClick={() => this.confirmDelMode(2)}><MDBIcon icon="shopping-cart" />&nbsp;Checkout<br /> (Pay Now With Debit/Credit Card)</MDBBtn>
                                )
                                :
                                (
                                    <div hidden={this.state.dirty}>
                                        <MDBBtn rounded disabled={this.state.cartData.cartItems.length == 0 || this.state.disabled} color="purple" size="sm" onClick={() => this.confirmDelMode(3)}><MDBIcon icon="shopping-cart" />&nbsp;Checkout<br /> (Pay Now With Debit/Credit Card)</MDBBtn>

                                        <MDBInput getValue={this.changeHandler} value={this.state.acceptedTerms} label="I accept the Terms and Conditions" type="checkbox" name="acceptedTerms" id="acceptedTerms" />
                                    </div>
                                )

                        ) : (
                        <div></div>
                    )}
                </MDBCol>
            )
        }
    }

    getDeliveryOptionsDisplay(isExperienceCenter) {

        if (isExperienceCenter) {
            return (<div></div>)
        } else {
            if (this.TMAUser.data.countryId === 6) {
                if (this.state.checked) {
                    return (<div key="DelOptsCart">
                        <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>

                            <span><MDBIcon icon="truck" />&nbsp;Dispatch Option</span><br /><div style={{ paddingTop: "5px", marginLeft: "35px", fontSize: "14px", fontWeight: "normal" }} id='helperTextExample' className='form-helper'>Deliver To Manager</div>
                        </MDBCardTitle></div>)
                }
                
                    return (<div key="DelOptsCart">
                        <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>

                            <span><MDBIcon icon="truck" />&nbsp;Dispatch Option</span><br /><div style={{ paddingTop: "5px", marginLeft: "35px", fontSize: "14px", fontWeight: "normal" }} id='helperTextExample' className='form-helper'>{this.state.selectedDeliveryCharge.description}</div>
                        </MDBCardTitle></div>)
                
                
            } else {
                return (
                    <div key="DelOpts">
                        <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>

                            <MDBIcon icon="truck" />&nbsp;Delivery Options
                        </MDBCardTitle>
                        {this.TMAUser.data.countryId == 6 && this.TMAUser.data.statusCode1 == "D" && this.state.showDeliverToManager ? <div hidden={this.state.isCollection} style={{ fontWeight: "bold" }}>



                            <MDBInput checked={this.state.checked} getValue={this.setChecked} value={this.state.checked} label="Deliver To My Manager" type="checkbox" name="deliverMan" id="deliverMan">
                                <div style={{ marginLeft: "35px", fontSize: "12px", fontWeight: "normal" }} id='helperTextExample' className='form-helper'>
                                    (PLEASE NOTE, IF YOU CHECK THIS BOX, YOUR ORDER WILL BE DELIVERED TO YOUR MANAGERS ADDRESS)
                                </div>
                            </MDBInput>



                        </div> : <div></div>}

                        <SelectSearch
                            options={this.state.deliveryOptions}
                            placeholder="Delivery Option"
                            value={this.state.selectedDeliveryOption}
                            search={false}
                            onChange={(selectedItem) => {
                                this.filterCharges(selectedItem.value)
                            }}
                        />
                        <SelectSearch
                            options={this.state.filteredCharges}
                            placeholder="Delivery Charge"
                            value={this.state.selectedDeliveryCharge}
                            search={false}
                            onChange={(selectedItem) => {
                                this.setState({
                                    selectedDeliveryCharge: selectedItem.value
                                })
                                this.updateCart();
                            }}
                        />

                    </div>
                )
            }
        }
    }

    getKitDisplay() {
        if (this.state.showKit) {
            return (
                <div>

                    <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                        <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>
                            <MDBIcon icon="cubes" className="green-text" />&nbsp;Congratulations You Qualify For The Following Kit
                        </MDBCardTitle>
                        <MDBCol sm="12">
                            <span style={{ color: Colors.purple, fontWeight: "bold" }}>{this.state.availableSfKit.invoiceDescription}</span>
                            <br />
                        </MDBCol>
                        <MDBCol md="6" sm="12">
                            <MDBRow>
                                <MDBCol>
                                    <span style={{ fontSize: "14px" }}>Code: {this.state.availableSfKit.processingCode}</span><br />
                                    <span style={{ fontSize: "14px" }}>Retail: {this.formatter.formatCurrency(this.state.availableSfKit.recognition)}</span>
                                </MDBCol>
                                <MDBCol className="text-right">
                                    <span style={{ fontSize: "14px" }}>Price: {this.formatter.formatCurrency(this.state.availableSfKit.d)}</span><br />
                                </MDBCol>
                            </MDBRow>
                            <span className="cartAddKit" onClick={() => this.addKit(this.state.availableSfKit)}><MDBIcon icon="cart-plus" /> Add To Cart</span>
                        </MDBCol>


                        <hr className="hr_grey" />
                    </MDBCard>
                </div>
            )
        } else {
            return (<div></div>)
        }
    }

    getCartSummary(isExperienceCenter, disableEcCheckout) {
        //if (this.TMAUser.data.paymentGatewayId == 2) {
        if (this.TMAUser.data.countryId == 11) {
            //let nhil = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (2.5 / 100)
            //let gfl = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (2.5 / 100)
            //let chrl = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (1 / 100);
            let GETFund = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (2.5 / 100)
            let NHIS = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (2.5 / 100)
            let subtotal = (this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue;

            //GETFund = GETFund.toFixed(2) * 1;
            //NHIS = NHIS.toFixed(2) * 1;
            //subtotal = subtotal.toFixed(2) * 1;

            GETFund = Math.round((GETFund + Number.EPSILON) * 100) / 100;
            NHIS = Math.round((NHIS + Number.EPSILON) * 100) / 100;
            subtotal = Math.round((subtotal + Number.EPSILON) * 100) / 100;

            //subtotal += nhil + gfl + chrl
            let ghanaTax = subtotal * (this.TMAUser.data.taxRate / 100);
            ghanaTax = Math.round((ghanaTax + Number.EPSILON) * 100) / 100;
            let ghanaInvoiceTotal = subtotal + ghanaTax + NHIS + GETFund;
            ghanaInvoiceTotal = Math.round((ghanaInvoiceTotal + Number.EPSILON) * 100) / 100;
            let myTest = "";
            return (

                <MDBRow className="mx-1">
                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem">Items Total:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.itemsTotal)}</div>
                    </MDBCol>
                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem">Delivery Charge:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.deliveryCharge)}</div>
                    </MDBCol>
                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem"> Fixed Charge:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.fixedCharge)}</div>
                    </MDBCol>
                    <MDBCol sm="12">
                        <hr className="hr_grey" />
                    </MDBCol>
                    <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                        <div className="cartSummaryItem">Total Excl.:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.subTotal)}</div>
                    </MDBCol>

                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem">Rounding:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.rounding)}</div>
                    </MDBCol>
                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem">Discount:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.discountValue)}</div>
                    </MDBCol>

                    <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                        <div className="cartSummaryItem"> </div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)}</div>
                    </MDBCol>

                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem">GET Fund:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(GETFund)}</div>
                    </MDBCol>
                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem">NHIS:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(NHIS)}</div>
                    </MDBCol>

                    {/*<MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>*/}
                    {/*    <div className="cartSummaryItem">NHIL:</div>*/}
                    {/*    <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(nhil)}</div>*/}
                    {/*</MDBCol>*/}
                    {/*<MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>*/}
                    {/*    <div className="cartSummaryItem">GFL:</div>*/}
                    {/*    <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(gfl)}</div>*/}
                    {/*</MDBCol>*/}
                    {/*<MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>*/}
                    {/*    <div className="cartSummaryItem">CHRL:</div>*/}
                    {/*    <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(chrl)}</div>*/}
                    {/*</MDBCol>*/}

                    {/*<MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>*/}
                    {/*    <div className="cartSummaryItem">Sub Total:</div>*/}
                    {/*    <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(subtotal)}</div>*/}
                    {/*</MDBCol>*/}

                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem">Tax:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(ghanaTax)}</div>
                    </MDBCol>

                    <MDBCol sm="12">
                        <hr className="hr_grey" />
                    </MDBCol>
                    <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                        <div className="cartSummaryItem">{this.state.documentType} Total:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(ghanaInvoiceTotal)}</div>
                    </MDBCol>



                    <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                        <div className="cartSummaryItem">Recognition Total:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.recognitionTotal)}</div>
                    </MDBCol>
                    <MDBCol sm="12">
                        <hr className="hr_grey" />
                    </MDBCol>
                    {this.getCartButtons(isExperienceCenter, disableEcCheckout)}

                </MDBRow>

            )
        } else {
            return (

                <MDBRow>
                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem">Items Total:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.itemsTotal)}</div>
                    </MDBCol>
                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem">Delivery Charge:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.deliveryCharge)}</div>
                    </MDBCol>
                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem"> Fixed Charge:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.fixedCharge)}</div>
                    </MDBCol>
                    <MDBCol sm="12">
                        <hr className="hr_grey" />
                    </MDBCol>
                    <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                        <div className="cartSummaryItem">Sub Total:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.subTotal)}</div>
                    </MDBCol>
                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem">VAT:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.vat)}</div>
                    </MDBCol>
                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem">Rounding:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.rounding)}</div>
                    </MDBCol>
                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <MDBIcon icon="fire-alt" className="red-text" />&nbsp;<div className="cartSummaryItem">Discount:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.discountValue)}</div>
                    </MDBCol>
                    <MDBCol sm="12">
                        <hr className="hr_grey" />
                    </MDBCol>
                    <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                        <div className="cartSummaryItem">Order Total:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.orderTotal)}</div>
                    </MDBCol>
                    <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                        <div className="cartSummaryItem">Recognition Total:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.recognitionTotal)}</div>
                    </MDBCol>
                    <MDBCol sm="12">
                        <hr className="hr_grey" />
                    </MDBCol>
                    {this.TMAUser.data.paymentGatewayId == 1 ?

                        <MDBCol sm="12">
                            <label htmlFor="sfComment">Invoice Comment</label>
                            <textarea className="form-control" id="sfComment" rows="5" onChange={(event) => this.handleCommentChange(event)} />
                        </MDBCol>
                        : <div></div>}

                    {/*buttons here*/}
                    {this.getCartButtons(isExperienceCenter, disableEcCheckout)}

                </MDBRow>

            )
        }
    }

    getDelOptionMsg() {
        if (this.state.checked) {
            return (
                <MDBModalBody>
                    You have chosen for your order to be delivered to your manager. Is this correct?
                </MDBModalBody>
            )
        }
        if (this.state.selectedDeliveryOption == 1) {
            var collectionPointDescription = this.state.selectedDeliveryCharge.description
            return (
                <MDBModalBody>
                    You have chosen for your order to be collected. The Collection Point is <span style={{ fontWeight: "bold" }}>{ collectionPointDescription}</span>. Is this correct?
                </MDBModalBody>
            )
        }
        if (this.state.selectedDeliveryOption == 2) {
            return (
                <MDBModalBody>
                    You have chosen for your order to be delivered to your delivery address. Is this correct?
                </MDBModalBody>
            )
        }
    }

    getCopaymentDisplay() {
        if (this.state.copaymentsData.length > 0) {
            var test = this.state.copaymentsData[0].levelDescription
            return (
                <MDBContainer style={{ marginTop: "9px" }} fluid>
                    <span style={{ fontWeight: "bold" }}><MDBIcon icon="handshake" className="green-text" />&nbsp;You Qualify For The Following Co-Payments</span>
                    <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                        <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>
                            {test}
                            <hr />
                            <MDBRow>
                                <MDBCol xl="12" lg="12" md="12" sm="12">{this.state.copaymentsData[0].invoiceDescription}</MDBCol>
                                <MDBCol xl="12" lg="12" md="12" sm="12">Price: {this.formatter.formatCurrency(this.state.copaymentsData[0].price)}</MDBCol>
                                <MDBCol xl="12" lg="12" md="12" sm="12">Retail: {this.formatter.formatCurrency(this.state.copaymentsData[0].retail)}</MDBCol>
                                <MDBCol xl="12" lg="12" md="12" sm="12">Valued At: {this.formatter.formatCurrency(this.state.copaymentsData[0].valuedAt)}</MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol xl="12" lg="12" md="12" sm="12">
                                    <MDBBtn rounded color="purple" size="sm" onClick={() => this.addCPToCart(this.state.copaymentsData[0])}><MDBIcon icon="plus" />&nbsp;Add</MDBBtn>
                                </MDBCol></MDBRow>
                        </MDBCardTitle>
                    </MDBCard>
                </MDBContainer>
            )
        }

    }

    getLocationDisplay(item) {
        try {
            if (item.avReservationWHCode != null && item.avFullfillmentWHCode != null) {
                var resWH = item.avReservationWHCode;
                var fullfillWH = item.avFullfillmentWHCode;
                resWH = resWH.toLowerCase();
                fullfillWH = fullfillWH.toLowerCase();
                var ttsft = '';
                if (item.avReservationWHCode === item.avFullfillmentWHCode) {
                    return (
                        <MDBRow className="mx-2" between>
                            <MDBCol sm="12"><div><span style={{ fontSize: "12px", backgroundColor: "#d9f7d7", padding: "5px", color: "#188210", fontWeight: "bold" }}>Reserved at {resWH === "prim" ? <span>Primary - </span> : <span>GH - </span>}&nbsp;{fullfillWH === "prim" ? <span>Deliver From Primary</span> : <span>Collect From GH</span>}</span></div></MDBCol>
                        </MDBRow>
                    )
                } else {
                    return (
                        <MDBRow className="mx-2" between>
                            <MDBCol sm="12"><div><span style={{ fontSize: "12px", backgroundColor: "#f2d1d0", padding: "5px", color: "#a3070e", fontWeight: "bold" }}>Reserved at {resWH === "prim" ? <span>Primary - </span> : <span>GH - </span>}&nbsp;{fullfillWH === "prim" ? <span>Deliver From Primary</span> : <span>Collect From GH</span>}</span></div></MDBCol>
                        </MDBRow>
                    )
                }
            }
        } catch (exception) {
            console.log('indicator', exception);
        }
    }

    GetSpecialsSection() {
        console.log("Specials", this.state.specialsItemsDisplay)
        if (this.state.specialsItemsDisplay.length > 0) {
            var itemsLength = 0
            return (
                <MDBContainer style={{ marginTop: "9px" }} fluid>
                    <span style={{ fontWeight: "bold" }}><MDBIcon icon="fire-alt" className="red-text" />&nbsp;You Qualify For The Following {this.state.specialsItems.length === 1 ? "Special" : "Specials"}</span>

                    {this.state.specialsItemsDisplay.map((item) => {
                        itemsLength = item.outcomeList.length;
                        var itemCount = 0;
                        return (
                            <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>

                                    {item.description}&nbsp;{item.alreadyTaken ? <span>(Already Added)</span> : <span></span>}
                                    <hr />
                                    {item.outcomeList.map(outcomeItem => {
                                        itemCount++;
                                        return (
                                            item.andOr == 'A' ?
                                                <div key={outcomeItem.outcomeStockId}>
                                                    <MDBRow>
                                                        <MDBCol xl="12" lg="12" md="12" sm="12">{outcomeItem.outcomeDescription}</MDBCol>
                                                        <MDBCol xl="12" lg="12" md="12" sm="12">Price: {this.formatter.formatCurrency(outcomeItem.price)}</MDBCol>
                                                        <MDBCol xl="12" lg="12" md="12" sm="12">Retail: {this.formatter.formatCurrency(outcomeItem.retail)}</MDBCol>
                                                        <MDBCol xl="12" lg="12" md="12" sm="12">Max Qty: {outcomeItem.maxQty}</MDBCol>
                                                    </MDBRow>
                                                    {itemCount < itemsLength ?
                                                        <MDBRow>
                                                            <MDBCol className="text-center">AND</MDBCol>
                                                        </MDBRow> : itemCount == itemsLength ?
                                                            <MDBRow>
                                                                <MDBCol xl="12" lg="12" md="12" sm="12">
                                                                    <MDBBtn rounded color="purple" size="sm" onClick={() => this.addSpecial(outcomeItem)}><MDBIcon icon="plus" />&nbsp;Add</MDBBtn>
                                                                </MDBCol></MDBRow> : <div></div>
                                                    }

                                                </div> :
                                                <div key={outcomeItem.outcomeStockId}>
                                                    <MDBRow>
                                                        <MDBCol xl="12" lg="12" md="12" sm="12">{outcomeItem.outcomeDescription}</MDBCol>
                                                        <MDBCol xl="12" lg="12" md="12" sm="12">Price: {this.formatter.formatCurrency(outcomeItem.price)}</MDBCol>
                                                        <MDBCol xl="12" lg="12" md="12" sm="12">Retail: {this.formatter.formatCurrency(outcomeItem.retail)}</MDBCol>
                                                        <MDBCol xl="12" lg="12" md="12" sm="12">Max Qty: {outcomeItem.maxQty}</MDBCol>
                                                        {item.alreadyTaken ? <div></div> :
                                                            <MDBCol xl="12" lg="12" md="12" sm="12">
                                                                <MDBBtn rounded color="purple" size="sm" onClick={() => this.addSpecial(outcomeItem)}><MDBIcon icon="plus" />&nbsp;Add</MDBBtn>
                                                            </MDBCol>}

                                                    </MDBRow>

                                                    {itemCount < itemsLength ?
                                                        <MDBRow>
                                                            <MDBCol className="text-center">OR</MDBCol>
                                                        </MDBRow> : <div></div>
                                                    }
                                                </div>
                                        )
                                    })}
                                </MDBCardTitle>
                            </MDBCard>
                        )
                    })}
                </MDBContainer>


            )
        }
        //return (
        //    this.state.specialsItemsDisplay.length > 0 ? (
        //        <div>

        //            <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
        //                <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>
        //                    <MDBIcon icon="fire-alt" className="red-text" />&nbsp;You Qualify For The Following {this.state.specialsItems.length === 1 ? "Special" : "Specials"}
        //                </MDBCardTitle>
        //                <hr className="hr_grey" />
        //                {this.state.specialsItemsDisplay.map((item) => {

        //                    return (
        //                        item.outcomeType == "Or" ? <MDBCardText>
        //                            <MDBRow className="mx-2" between>
        //                                <MDBCol md="6" sm="12"><span style={{ color: Colors.purple, fontWeight: "bold" }}>{item.description}</span><br />
        //                                    <MDBRow>
        //                                        <MDBCol>
        //                                            <span style={{ fontSize: "14px" }}>Description: {item.otherItemDescription}</span>

        //                                        </MDBCol>
        //                                        <MDBCol className="text-right">
        //                                            <span style={{ fontSize: "14px" }}>Amount: {item.otherType === "Value" ? this.formatter.formatCurrency(item.otherItemValue) + " Off" : item.otherItemValue + "% Off"} </span><br />

        //                                        </MDBCol>
        //                                    </MDBRow>

        //                                </MDBCol>
        //                                <MDBCol md="3" sm="12">
        //                                    <MDBBtn rounded color="purple" size="sm" onClick={() => this.addSpecial(item)}><MDBIcon icon="plus" />&nbsp;Apply</MDBBtn>
        //                                </MDBCol>
        //                            </MDBRow>
        //                            <hr className="hr_grey" />
        //                        </MDBCardText>
        //                            :
        //                            <MDBCardText>
        //                                <MDBRow className="mx-2" between>
        //                                    <MDBCol md="6" sm="12"><span style={{ color: Colors.purple, fontWeight: "bold" }}>{item.description}</span><br />
        //                                        <MDBRow>
        //                                            <MDBCol>
        //                                                <span style={{ fontSize: "14px" }}>Price: {this.formatter.formatCurrency(item.d)}</span><br />
        //                                                <span style={{ fontSize: "14px" }}>Code: {item.buyProcessingCode === null ? item.getProcessingCode : item.buyProcessingCode}</span>
        //                                            </MDBCol>
        //                                            <MDBCol className="text-right">
        //                                                <span style={{ fontSize: "14px" }}>Recognition: {this.formatter.formatCurrency(item.recognition)}</span><br />
        //                                                <span style={{ fontSize: "14px", fontWeight: "bold" }}>Max Allowed: {item.maxAllowed}</span>
        //                                            </MDBCol>
        //                                        </MDBRow>

        //                                    </MDBCol>
        //                                    <MDBCol md="3" sm="12">
        //                                        <MDBBtn rounded color="purple" size="sm" onClick={() => this.addSpecial(item)}><MDBIcon icon="plus" />&nbsp;Add</MDBBtn>
        //                                    </MDBCol>
        //                                </MDBRow>
        //                                <hr className="hr_grey" />
        //                            </MDBCardText>

        //                    )
        //                })}
        //            </MDBCard>

        //        </div>)
        //        : (<div></div>)
        //    )
    }

    getQtyDisplay(item) {
        var ffs = "";
        //item.mustChangeReservationWH ? item.updatedQtyRequested > item.qtyAvailablePrimary ? <span style={{ fontWeight: "bold", fontSize: "12px" }}>Qty Available:&nbsp;{item.qtyAvailablePrimary}</span> : <div><span style={{ color: "green", fontWeight: "bold", fontSize: "12px" }}><MDBIcon fas icon="check" />&nbsp;Qty Available</span></div> : <div>Qty Available:&nbsp;{item.qtyAvailableSecondary}</div>
        if (item.currentReservationWh.toLowerCase() === 'prim') {
            if (item.updatedQtyRequested > item.qtyAvailablePrimary) {
                return (<div><span style={{ fontWeight: "bold", fontSize: "12px" }}>Qty Available:&nbsp;{item.qtyAvailablePrimary}</span></div>)
            } else {
                return (<div><span style={{ color: "green", fontWeight: "bold", fontSize: "12px" }}><MDBIcon fas icon="check" />&nbsp;Qty Available</span></div >)
            }
        } else {
            if (item.mustChangeReservationWH) {
                if (item.updatedQtyRequested > item.qtyAvailablePrimary) {
                    return (<div><span style={{ fontWeight: "bold", fontSize: "12px" }}>Qty Available:&nbsp;{item.qtyAvailablePrimary}</span></div>)
                } else {
                    return (<div><span style={{ color: "green", fontWeight: "bold", fontSize: "12px" }}><MDBIcon fas icon="check" />&nbsp;Qty Available</span></div >)
                }
            } else {
                if (item.updatedQtyRequested > item.qtyAvailableSecondary) {
                    return (<div><span style={{ fontWeight: "bold", fontSize: "12px" }}>Qty Available:&nbsp;{item.qtyAvailableSecondary}</span></div>)
                } else {
                    return (<div><span style={{ color: "green", fontWeight: "bold", fontSize: "12px" }}><MDBIcon fas icon="check" />&nbsp;Qty Available</span></div >)
                }
            }
        }
    }

    render() {
        let cartId = this.state.cartData.cartItems.length > 0 ? this.state.cartData.cartItems[0].cartId : '';
        let headerText = this.state.isExperienceCenter ? "Experience Center Express Checkout" : "Shopping Cart";
        let disableEcCheckout = false;
        if (this.state.cartData.cartItems.length == 0 || this.state.hasOrder) {
            disableEcCheckout = true
        }

        return (
            <div>

                <Header headerText={headerText}
                    subHeaderText="(Please note if there is no activity on your cart for 30mins or more it will automatically be cleared)"
                    hideSearch={true}
                />

                <form
                    className="needs-validation"
                    name="migsForm"
                    id="migsForm"
                    action="https://migs.mastercard.com.au/vpcpay"
                    method="post"
                ></form>
                {/* <TopSeller items={this.state.hotItems}/> */}
                {this.state.shopSuspended ? <div><br /><h5>Shop has temporarily been suspended by your distributor. Please check back soon.</h5></div> :
                    <MDBRow>

                        <MDBCol xl="8" lg="7" md="12">
                            {this.getCopaymentDisplay()}
                            {this.GetSpecialsSection()}
                            {this.getKitDisplay()}
                            <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                <MDBRow>
                                    <MDBCol lg="6">
                                        <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}><MDBIcon icon="list-ul" />&nbsp;{this.state.isExperienceCenter ? 'Express Items' : 'Items In Your Cart'}&nbsp;<MDBBadge color="purple">{this.state.cartData.cartItems.length}</MDBBadge></MDBCardTitle>
                                    </MDBCol>
                                    <MDBCol lg="6" className="text-right">
                                        <MDBCardTitle style={{ textDecoration: "underline", fontSize: "16px", paddingBottom: "3px" }}>{this.state.hasOrder ? (<div>Your Checkout Code is : <span style={{ fontWeight: 'bold', color: 'red', fontSize: '20px' }}>{this.state.orderNo}</span></div>) : (<div></div>)}</MDBCardTitle>
                                    </MDBCol>
                                </MDBRow>
                                <hr className="hr_grey" />
                                {
                                    this.state.cartData.cartItems.map((item, index) => {
                                        console.log('cart item dispaly', item)
                                        return (
                                            <div key={item.cartItemId}>
                                                {this.getLocationDisplay(item)}
                                                <MDBRow className="mx-2" between>
                                                    {/*<MDBCol>
                                                    <img src="https://mdbootstrap.com/img/Others/documentation/1.jpg" className="img-fluid" alt="" />
                                                </MDBCol>*/}
                                                    <MDBCol sm="12">
                                                        {item.specialItem ? <span style={{ color: Colors.purple, fontWeight: "bold" }}><MDBIcon icon="fire-alt" className="red-text" />&nbsp;{item.invoiceDescription}</span> : <span style={{ color: Colors.purple, fontWeight: "bold" }}>{item.invoiceDescription}</span>}
                                                        <br />
                                                    </MDBCol>
                                                    <MDBCol md="6" sm="12">
                                                        <MDBRow>
                                                            <MDBCol>
                                                                <span style={{ fontSize: "14px" }}>Code: {item.processingCode}</span><br />
                                                                <span style={{ fontSize: "14px" }}>Retail: {this.formatter.formatCurrency(item.retail / 100)}</span>
                                                            </MDBCol>
                                                            <MDBCol className="text-right">
                                                                <span style={{ fontSize: "14px" }}>Price: {this.formatter.formatCurrency(item.price / 100)}</span><br />
                                                                <span style={{ fontSize: "14px", fontWeight: "bold" }}>Total: {this.formatter.formatCurrency((item.price * item.qty) / 100)}</span>
                                                            </MDBCol>
                                                        </MDBRow>
                                                        <span className="cartRemoveItem" onClick={() => this.zeroItem(item)}><MDBIcon far icon="trash-alt" /> Remove Item</span>
                                                    </MDBCol>
                                                    <MDBCol md="3" sm="12">
                                                        <MDBInput disabled={item.kit ? true : disableEcCheckout} className="mb-0" type="number" label="Qty" value={item.qty} min={0} onChange={(event) => this.handleChange(event, item)} />
                                                    </MDBCol>
                                                </MDBRow><hr className="hr_grey" />

                                            </div>
                                        );
                                    })
                                }
                            </MDBCard>
                        </MDBCol>
                        <MDBCol>
                            <MDBCard className="card-body" style={{ marginTop: "1rem", color: this.state.dirty ? "#bdbdbf" : Colors.black }}>
                                {this.getDeliveryOptionsDisplay(this.state.isExperienceCenter)}
                                <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}><MDBIcon icon="file-signature" />&nbsp;{this.state.isExperienceCenter ? 'Summary' : 'Cart Summary'}</MDBCardTitle>
                                {this.getCartSummary(this.state.isExperienceCenter, disableEcCheckout)}
                            </MDBCard>
                        </MDBCol>
                        <div><script async src="https://widgets.payflex.co.za/your-merchant-name/partpay-widget-0.1.1.js?type=calculator&min=50&max=400&amount=300" type="application/javascript"></script></div>
                    </MDBRow>
                }
                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />

                <MDBModal isOpen={this.state.delModeOpen} toggle={this.state.delModeOpen} centered>
                    <MDBModalHeader>Important</MDBModalHeader>
                    {this.getDelOptionMsg()}

                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={() => this.CheckCreditBal(this.state.checkOutType)}>Yes Continue</MDBBtn>
                        <MDBBtn rounded color="secondary" onClick={() => this.setState({ delModeOpen: false })}>No Change</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.modalOpen} toggle={this.state.modalOpen} centered>
                    <MDBModalHeader>Important</MDBModalHeader>
                    <MDBModalBody>
                        Please do not refresh or close your browser once you have clicked pay now on the payment screen.
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.toggle}>Continue to Payment</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.payflexModalOPen} toggle={this.state.payflexModalOPen} centered>
                    <MDBModalHeader>{this.state.payFlexModalHeader}</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.payFlexMsg}
                    </MDBModalBody>
                    <div hidden={this.state.paflexModalButtonHidden}>
                        <MDBModalFooter>
                            <MDBBtn rounded color="secondary" onClick={() => this.setState({ payflexModalOPen: false, paflexModalButtonHidden: true })}>Ok</MDBBtn>

                        </MDBModalFooter>
                    </div>
                </MDBModal>


                <MDBModal isOpen={this.state.payflexInfoModalOpen} toggle={this.state.payflexInfoModalOpen} centered>
                    <MDBModalHeader>You are about to enter onto the Payflex payment portal.</MDBModalHeader>
                    <MDBModalBody>
                        <ol>
                            <li>You understand how Payflex works. If not close this screen and visit&nbsp;
                                <span style={{ textDecoration: "underline" }}><a href="https://payflex.co.za" target="_blank">payflex.co.za</a></span> and under the For Shoppers tab, watch their videos and read FAQ.
                            </li>
                            <li>I have registered with Payflex and have a Payflex account. If not, close this screen, and visit&nbsp;
                                <span style={{ textDecoration: "underline" }}><a href="https://payflex.co.za/customer-registration/" target="_blank">payflex.co.za/customer-registration/</a></span>
                            </li>
                            <li>You agree that the ID Number used MATCHES THE bank card loaded on Payflex. If you do not have your own bank card, close screen, and choose a different payment option.</li>
                        </ol>
                    </MDBModalBody>
                    <div>
                        <MDBModalFooter>
                            <MDBBtn rounded color="secondary" onClick={this.continueWithPayflex}>I agree, Continue With Payflex</MDBBtn>
                            <MDBBtn rounded color="secondary" onClick={() => this.setState({ payflexInfoModalOpen: false })}>Choose Different Payment Option</MDBBtn>
                        </MDBModalFooter>
                    </div>
                </MDBModal>

                <MDBModal isOpen={this.state.errorModalOpen} toggle={this.state.errorModalOpen} centered>
                    <MDBModalHeader>Alert</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.cartErrorMsg}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.toggleErrorInfo}>Click to Refresh</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.checkedOutModalOpen} toggle={this.state.checkedOutModalOpen} centered>
                    <MDBModalHeader>Info</MDBModalHeader>
                    <MDBModalBody>
                        Thank you for your order, we appreciate your business. Your reference number is ({this.state.orderReference}). You can view your invoice by clicking the view invoice button below.
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.toggleCheckedOutInfo}>View Invoice</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>

                <MDBModal size="lg" isOpen={this.state.qtyCheckModalOpen} toggle={this.state.qtyCheckModalOpen} centered>
                    <MDBModalHeader>
                        <MDBRow>
                            <MDBCol>
                                Adjust Cart Quantities
                                
                            </MDBCol>
                        </MDBRow>
                        
                    </MDBModalHeader>
                    <MDBModalBody>
                        <MDBRow>
                            <MDBCol><span style={{ fontSize: "12px", fontWeight: "bold" }}>(One or more items either need to be reserved at the Primary warehouse or the quantity requested exceeds the available quantity.
                                The items that exceeds the available quantity will reserve the available quantity for this order.)</span></MDBCol>
                        </MDBRow>
                        
                        <hr />
                        {this.state.updatedQuantitiesAV.map((item) => {
                            return (
                                <div>
                                <MDBRow>
                                        {item.mustChangeReservationWH ? <MDBCol><span style={{ fontSize: "12px", backgroundColor: "#f2d1d0", padding: "5px", color: "#a3070e", fontWeight: "bold" }}>This Item Needs to be Reserved At Primary WH</span></MDBCol>: <div></div>}
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol sm="12" md="6">
                                        <span style={{ fontWeight: "bold", fontSize: "12px" }}>{item.invoiceDescription}</span>
                                    </MDBCol>
                                    <MDBCol sm="12" md="3">
                                        <span style={{ fontWeight: "bold", fontSize: "12px" }}>New Qty:&nbsp;{item.updatedQtyRequested}</span>
                                    </MDBCol>
                                        <MDBCol sm="12" md="3">
                                            {
                                                this.getQtyDisplay(item)
                                            }

                                        
                                        
                                    </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol sm="12">
                                                            <hr className="hr_grey" />
                                                       </MDBCol>
                                    </MDBRow>
                                </div>
                            )
                        })}
                        {/*{this.state.stockLimitsData.map((item) => {*/}
                        {/*    return (*/}
                        {/*        <MDBRow>*/}
                        {/*            <MDBCol sm="12" md="6">*/}
                        {/*                <span style={{ fontWeight: "bold", fontSize: "12px" }}>{item.invoiceDescription}</span>*/}
                        {/*            </MDBCol>*/}
                        {/*            <MDBCol sm="12" md="3">*/}
                        {/*                <span style={{ fontWeight: "bold", fontSize: "12px" }}>Qty:&nbsp;{item.qty}</span>*/}
                        {/*            </MDBCol>*/}
                        {/*            <MDBCol sm="12" md="3">*/}
                        {/*                <span style={{ fontWeight: "bold", fontSize: "12px" }}>Available:&nbsp;{item.availableToOrder}</span>*/}
                        {/*            </MDBCol>*/}
                        {/*            <MDBCol sm="12">*/}
                        {/*                <hr className="hr_grey" />*/}
                        {/*            </MDBCol>*/}
                        {/*        </MDBRow>*/}

                        {/*    )*/}
                        {/*})}*/}
                        
                    </MDBModalBody>
                    <MDBModalFooter>
                        
                        <MDBBtn rounded color="secondary" onClick={this.ApplyAvailableQtys}>Apply Qty's & Update</MDBBtn>


                        <MDBBtn rounded color="secondary" onClick={this.toggleQtyCheckInfo}>Close</MDBBtn>
                        

                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.cartSyncModalOpen} toggle={this.state.cartSyncModalOpen} centered>
                    <MDBModalHeader><span style={{ color: "red" }}><MDBIcon icon="exclamation-triangle" /></span>&nbsp;Cart Error</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.cartSyncMessage}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.forceUpdate}>Refresh Cart</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.sessionSyncModal} toggle={this.state.sessionSyncModal} centered>
                    <MDBModalHeader><span style={{ color: "red" }}><MDBIcon icon="exclamation-triangle" /></span>&nbsp;Session Error</MDBModalHeader>
                    <MDBModalBody>
                        This Window is out of sync, please login again to complete checkout.
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.accessManager.logout}>Ok</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.balModalOpen} toggle={this.state.balModalOpen} centered>
                    <MDBModalHeader><span style={{ color: "green" }}><MDBIcon fas icon="coins" /></span>&nbsp;Available Credit</MDBModalHeader>
                    <MDBModalBody>
                        You have {this.formatter.formatCurrency(this.state.availableCredit)} credit available, would you like to use it for this purchase?
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={() => this.useCredit(true)}>Yes</MDBBtn>
                        <MDBBtn rounded color="secondary" onClick={() => this.useCredit(false)}>No</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.addressModalOpen} toggle={this.state.addressModalOpen} centered>
                    <MDBModalHeader><span style={{ color: "red" }}><MDBIcon fas icon="times" /></span>&nbsp;Address Verification</MDBModalHeader>
                    <MDBModalBody>
                        <p>We are unable to verify your delivery address. Please click Update Delivery Address below and then return to your cart once you have updated your delivery address.</p>
                        <p style={{fontWeight: "bold"}}>Make sure to Update Town/Suburb and Post Code fields</p>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={() => this.props.history.push('/salesforce/personalInfo')}>Update Delivery Address</MDBBtn>
                        
                    </MDBModalFooter>
                </MDBModal>
            </div>

        )
    }
}

export default Cart;